var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-form" }, [
    _c("div", { staticClass: "filter-container clearfix" }, [
      _c(
        "div",
        { staticClass: "left-tools" },
        [
          _c(
            "el-popover",
            { attrs: { placement: "bottom-start", trigger: "click" } },
            [
              _c("div", { staticClass: "cols-setting" }, [
                _c(
                  "ul",
                  _vm._l(
                    (_vm.handle && _vm.handle.filterFieldList) || [],
                    function(item, index) {
                      return _c(
                        "li",
                        { key: index },
                        [
                          _c(
                            "el-checkbox",
                            {
                              key: index,
                              staticClass: "filter-item",
                              attrs: { label: item.label },
                              on: {
                                change: function(e) {
                                  return _vm.checkboxOnChange(e, item)
                                }
                              },
                              model: {
                                value: item.value,
                                callback: function($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t(item.label)))]
                          )
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              ]),
              _vm._v(" "),
              _c("el-button", {
                attrs: {
                  slot: "reference",
                  icon: "el-icon-s-tools",
                  size: "mini"
                },
                slot: "reference"
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm._toggle }
            },
            [
              _c(
                "span",
                { staticClass: "custom-icon" },
                [_c("svg-icon", { attrs: { "icon-class": "filter" } })],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "right-tools" }, [
        _c(
          "div",
          { staticClass: "pull-right" },
          [
            _vm._l((_vm.handle && _vm.handle.btList) || [], function(
              item,
              index
            ) {
              return [
                item.type === "button"
                  ? _c(
                      "el-tooltip",
                      {
                        key: index,
                        staticClass: "item",
                        attrs: {
                          content: item.content,
                          disabled: item.tipDisabled !== false || false,
                          placement: "bottom-start"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.show,
                                expression: "item.show"
                              },
                              { name: "waves", rawName: "v-waves" }
                            ],
                            key: index,
                            class: "filter-" + item.type,
                            staticStyle: { "margin-right": "5px" },
                            attrs: {
                              plain: item.plain,
                              type: item.btType,
                              icon: item.icon,
                              disabled: item.disabled,
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleClick(item.event)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t(item.label)))]
                        )
                      ],
                      1
                    )
                  : item.type === "button-mini"
                  ? _c(
                      "el-tooltip",
                      {
                        key: index,
                        staticClass: "item",
                        attrs: {
                          content: item.content,
                          disabled: item.tipDisabled !== false || false,
                          placement: "bottom-start"
                        }
                      },
                      [
                        _c(
                          "el-button-group",
                          [
                            _vm._t("import"),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  { name: "waves", rawName: "v-waves" }
                                ],
                                attrs: {
                                  type: item.btType,
                                  icon: item.icon,
                                  disabled: item.disabled,
                                  size: "mini"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleClick(item.event)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t(item.label)))]
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.searchForm
      ? _c(
          "div",
          { staticClass: "search-form clearfix" },
          [
            _c(
              "el-form",
              {
                ref: "pageform",
                attrs: {
                  inline: true,
                  model: _vm.data,
                  rules: _vm.rules,
                  size: "mini",
                  "label-width": "auto"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 10 } },
                  [
                    _vm._l(_vm.getConfigList(), function(item, index) {
                      return [
                        item.type == "input"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t(item.label) } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: item.type,
                                        disabled: item.disabled,
                                        clearable:
                                          item.clearable === false
                                            ? item.clearable
                                            : true,
                                        placeholder: _vm.getPlaceholder(item)
                                      },
                                      on: {
                                        focus: function($event) {
                                          return _vm.handleEvent(item.event)
                                        }
                                      },
                                      model: {
                                        value: _vm.data[item.value],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, item.value, $$v)
                                        },
                                        expression: "data[item.value]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "inputRequire"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: item.value,
                                      label: _vm.$t(item.label),
                                      required: item.required
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: item.type,
                                        disabled: item.disabled,
                                        clearable:
                                          item.clearable === false
                                            ? item.clearable
                                            : true,
                                        placeholder: _vm.getPlaceholder(item)
                                      },
                                      on: {
                                        focus: function($event) {
                                          return _vm.handleEvent(item.event)
                                        }
                                      },
                                      model: {
                                        value: _vm.data[item.value],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, item.value, $$v)
                                        },
                                        expression: "data[item.value]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "textarea"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: item.value,
                                      label: _vm.$t(item.label),
                                      required: item.required
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: item.type,
                                        autosize: item.autosize || {
                                          minRows: 1,
                                          maxRows: 4
                                        },
                                        disabled: item.disabled,
                                        clearable:
                                          item.clearable === false
                                            ? item.clearable
                                            : true,
                                        placeholder: _vm.getPlaceholder(item)
                                      },
                                      on: {
                                        focus: function($event) {
                                          return _vm.handleEvent(item.event)
                                        }
                                      },
                                      model: {
                                        value: _vm.data[item.value],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, item.value, $$v)
                                        },
                                        expression: "data[item.value]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "select"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t(item.label) } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          "label-width": item.labelWidth,
                                          disabled: item.disabled,
                                          clearable:
                                            item.clearable === false
                                              ? item.clearable
                                              : true,
                                          multiple:
                                            item.multiple === true
                                              ? item.multiple
                                              : false,
                                          filterable: item.filterable,
                                          remote: item.remote,
                                          placeholder: _vm.getPlaceholder(item)
                                        },
                                        on: {
                                          focus: function($event) {
                                            return _vm.handleEvent(
                                              item.eventFocus,
                                              item
                                            )
                                          },
                                          change: function($event) {
                                            return _vm.handleEvent(
                                              item.event,
                                              _vm.data[item.value]
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      },
                                      _vm._l(
                                        _vm.listTypeInfo[item.list],
                                        function(childItem, childIndex) {
                                          return _c("el-option", {
                                            key: childIndex,
                                            attrs: {
                                              label: childItem.key,
                                              value: childItem.value
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "selectRequired"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: item.value,
                                      label: _vm.$t(item.label),
                                      required: item.required
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          "label-width": item.labelWidth,
                                          disabled: item.disabled,
                                          clearable:
                                            item.clearable === false
                                              ? item.clearable
                                              : true,
                                          multiple:
                                            item.multiple === true
                                              ? item.multiple
                                              : false,
                                          filterable: item.filterable,
                                          placeholder: _vm.getPlaceholder(item)
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.handleEvent(
                                              item.event,
                                              _vm.data[item.value]
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      },
                                      _vm._l(
                                        _vm.listTypeInfo[item.list],
                                        function(childItem, childIndex) {
                                          return _c("el-option", {
                                            key: childIndex,
                                            attrs: {
                                              label: childItem.key,
                                              value: childItem.value
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "select-brand"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t(item.label) } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          "label-width": item.labelWidth,
                                          disabled: item.disabled,
                                          clearable:
                                            item.clearable === false
                                              ? item.clearable
                                              : true,
                                          multiple:
                                            item.multiple === true
                                              ? item.multiple
                                              : false,
                                          filterable: item.filterable,
                                          placeholder: _vm.getPlaceholder(item)
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.$forceUpdate()
                                          }
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      },
                                      _vm._l(
                                        _vm.listTypeInfo[item.list],
                                        function(childItem, childIndex) {
                                          return _c("el-option", {
                                            key: childIndex,
                                            attrs: {
                                              label: childItem.key,
                                              value: childItem.value
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    (item.switchBrandFlag === true
                                    ? true
                                    : false)
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleClick(
                                                  item.switchEvent,
                                                  _vm.data[item.value]
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("切换")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "datepicker"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: {
                                  xs: 24,
                                  sm: 24,
                                  md: 24,
                                  lg: 12,
                                  xl: 12
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t(item.label) } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "daterange",
                                        align: "right",
                                        "unlink-panels": "",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "picker-options": item.pickerOptions
                                      },
                                      model: {
                                        value: _vm.data[item.value],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, item.value, $$v)
                                        },
                                        expression: "data[item.value]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "datetimepicker"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: {
                                  xs: 24,
                                  sm: 24,
                                  md: 24,
                                  lg: 12,
                                  xl: 12
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t(item.label) } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd HH:mm",
                                        format: "yyyy-MM-dd HH:mm",
                                        type: "datetimerange",
                                        align: "right",
                                        "unlink-panels": "",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "picker-options": item.pickerOptions
                                      },
                                      model: {
                                        value: _vm.data[item.value],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, item.value, $$v)
                                        },
                                        expression: "data[item.value]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "date"
                          ? _c(
                              "el-col",
                              { key: index },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t(item.label) } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd",
                                        type: "date",
                                        align: "right",
                                        "default-value": new Date(),
                                        "picker-options": item.pickerOptions
                                      },
                                      model: {
                                        value: _vm.data[item.value],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, item.value, $$v)
                                        },
                                        expression: "data[item.value]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "datetime"
                          ? _c(
                              "el-col",
                              { key: index },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t(item.label) } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "datetime",
                                        align: "right",
                                        "default-value": new Date(),
                                        "picker-options": item.pickerOptions
                                      },
                                      model: {
                                        value: _vm.data[item.value],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, item.value, $$v)
                                        },
                                        expression: "data[item.value]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "radio"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t(item.label) } },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: item.yes || "Y",
                                          placeholder:
                                            item.yesLabel ||
                                            _vm.getPlaceholder(item)
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.yesLabel || _vm.$t("table.yes")
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: item.no || "N",
                                          placeholder:
                                            item.noLabel ||
                                            _vm.getPlaceholder(item)
                                        },
                                        model: {
                                          value: _vm.data[item.value],
                                          callback: function($$v) {
                                            _vm.$set(_vm.data, item.value, $$v)
                                          },
                                          expression: "data[item.value]"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.noLabel || _vm.$t("table.no")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.type == "line-input"
                          ? _c(
                              "el-col",
                              {
                                key: index,
                                attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t(item.label) } },
                                  [
                                    _vm._v(
                                      "\n              SO-\n              "
                                    ),
                                    _c("el-input", {
                                      staticClass: "line-input",
                                      attrs: { label: "", placeholder: "" },
                                      model: {
                                        value: _vm.data[item.value][0],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data[item.value], 0, $$v)
                                        },
                                        expression: "data[item.value][0]"
                                      }
                                    }),
                                    _vm._v(
                                      "\n              至\n              "
                                    ),
                                    _c("el-input", {
                                      staticClass: "line-input",
                                      attrs: { label: "", placeholder: "" },
                                      model: {
                                        value: _vm.data[item.value][1],
                                        callback: function($$v) {
                                          _vm.$set(_vm.data[item.value], 1, $$v)
                                        },
                                        expression: "data[item.value][1]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  _vm._l((_vm.handle && _vm.handle.formBtList) || [], function(
                    item,
                    index
                  ) {
                    return _c(
                      "el-button",
                      {
                        directives: [{ name: "waves", rawName: "v-waves" }],
                        key: index,
                        class: "filter-" + item.type,
                        attrs: {
                          type: item.btType,
                          icon: item.icon,
                          disabled: item.disabled,
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleClick(item.event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t(item.label)))]
                    )
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3612484c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3612484c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/top-form.vue
// module id = null
// module chunks = 